import { render, staticRenderFns } from "./ECertModal.vue?vue&type=template&id=f9cef38a&scoped=true"
import script from "./ECertModal.vue?vue&type=script&lang=js"
export * from "./ECertModal.vue?vue&type=script&lang=js"
import style0 from "./ECertModal.vue?vue&type=style&index=0&id=f9cef38a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9cef38a",
  null
  
)

export default component.exports